import React, { useMemo, useState } from "react";
import { Snackbar } from "@mui/material";
import { useReceiptData } from "../handlers/useReceiptData";
import ReceiptHeader from "../ReceiptHeader";
import AlertBar from "../../common/alert";
import TapPaymentSuccessCard from "./TapPaymentSuccessCard";
import TapPaymentPendingCard from "./TapPaymentPendingCard";
import TapPaymentFailedCard from "./TapPaymentFailedCard";

/**
 * Read-only receipt view for a MOBILE_PAYMENT tx — there is no in-page payment step to
 * orchestrate (the tap already happened on the driver's phone via NFC before this page is ever
 * opened), so this deliberately does not mirror QRPaymentPage's postMessage/LoadingModal payment
 * machinery. `useReceiptData`'s existing polling (refetchInterval) is what turns PENDING_PAYMENT
 * into SUCCESS/FAILURE on screen once the driver's confirm request lands.
 */
const MobilePaymentPage: React.FC = () => {
  const [alert, setAlert] = useState({
    show: false,
    severity: "info",
    title: "",
    message: "",
  });
  const { data } = useReceiptData(setAlert);

  const status = useMemo(() => {
    switch (data?.status) {
      case "PENDING_PAYMENT":
      case "SUCCESS":
      case "FAILURE":
        return data.status;
      default:
        return "UNKNOWN";
    }
  }, [data?.status]);

  return (
    <div className="bg-nobel-50 min-h-screen w-full flex flex-col content-center mx-auto">
      <div className="shrink-0">
        <ReceiptHeader data={data} />
      </div>
      <div className="flex flex-col w-full max-w-7xl mx-auto">
        <div className="w-full">
          {status === "PENDING_PAYMENT" && <TapPaymentPendingCard />}
          {status === "SUCCESS" && <TapPaymentSuccessCard data={data as any} />}
          {status === "FAILURE" && <TapPaymentFailedCard />}
        </div>
      </div>
      <Snackbar
        open={!!alert.show}
        sx={{ width: "95%" }}
        autoHideDuration={60000}
        onClose={() => setAlert({ ...alert, show: false })}
      >
        <AlertBar
          severity={alert.severity as any}
          show={!!alert.show}
          title={alert.title}
          message={typeof alert.message === "string" ? alert.message : ""}
          onClose={() => setAlert({ ...alert, show: false })}
        />
      </Snackbar>
    </div>
  );
};

export default MobilePaymentPage;
